import {MeasurementIdentifiers} from "@/Constants";

export class MeasurementIdentifierHelper {

    public static Symptoms(): string[] {
        return [
            MeasurementIdentifiers.WeightLoss,
            MeasurementIdentifiers.Fever,
            MeasurementIdentifiers.Tiredness,
            MeasurementIdentifiers.SleepDisturbances,
            MeasurementIdentifiers.Headache,
            MeasurementIdentifiers.Migraine,
            MeasurementIdentifiers.VisionDisorders,
            MeasurementIdentifiers.Dizziness,
            MeasurementIdentifiers.SensoryDisturbances,
            MeasurementIdentifiers.Breathlessness,
            MeasurementIdentifiers.HeartPalpitations,
            MeasurementIdentifiers.ChestPain,
            MeasurementIdentifiers.LowerLegSwelling,
            MeasurementIdentifiers.Cough,
            MeasurementIdentifiers.MucusFormation,
            MeasurementIdentifiers.AbdominalPains,
            MeasurementIdentifiers.Nausea,
            MeasurementIdentifiers.AcidReflux,
            MeasurementIdentifiers.Heartburn,
            MeasurementIdentifiers.Vomiting,
            MeasurementIdentifiers.WeightGain,
            MeasurementIdentifiers.HardStools,
            MeasurementIdentifiers.UrinationProblems,
            MeasurementIdentifiers.MenstrualProblems,
            MeasurementIdentifiers.Menopause,
            MeasurementIdentifiers.ArmsLegsSkinJoints_Pain,
            MeasurementIdentifiers.ArmsLegsSkinJoints_Tingling,
            MeasurementIdentifiers.ArmsLegsSkinJoints_Sting,
            MeasurementIdentifiers.ArmsLegsSkinJoints_Rash,
            MeasurementIdentifiers.ArmsLegsSkinJoints_Swelling,
            MeasurementIdentifiers.ArmsLegsSkinJoints_ReducedMobility,
        ];
    }

    public static ObjectivePsychic(): string[] {
        return [
            MeasurementIdentifiers.Anxiety,
            MeasurementIdentifiers.Depression,
            MeasurementIdentifiers.Stress,
            MeasurementIdentifiers.SuicidalThoughts,
        ];
    }

    public static Anamnesis(): string[] {
        return [
            MeasurementIdentifiers.Alcohol,
            MeasurementIdentifiers.Tobacco,
            MeasurementIdentifiers.Drugs,
            MeasurementIdentifiers.DispositionsForCommonDiseases,
            MeasurementIdentifiers.DispositionsForMentalDiseases,
            MeasurementIdentifiers.PreviousIllnessesAndTreatments,
        ];
    }
}
